import { stringEnum } from '@/models/type-generators/string-enum';

export type MatrixProcessMessageType = 'STRUCTURAL' | 'CONTROL' | 'PARSE' | 'SAVE' | 'COMPLETE' | 'UNKNOWN';
export const MatrixProcessMessageType = stringEnum<MatrixProcessMessageType>();
